var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#2AA9E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.643 12.9371C30.808 13.3071 29.911 13.5571 28.968 13.6701C29.941 13.0879 30.669 12.1715 31.016 11.0921C30.1019 11.6351 29.1014 12.0173 28.058 12.2221C27.3564 11.4729 26.4271 10.9764 25.4143 10.8096C24.4016 10.6427 23.3621 10.8149 22.4572 11.2993C21.5524 11.7838 20.8328 12.5534 20.4102 13.4888C19.9875 14.4241 19.8855 15.4728 20.12 16.4721C18.2677 16.3791 16.4556 15.8976 14.8014 15.059C13.1472 14.2203 11.6879 13.0432 10.518 11.6041C10.118 12.2941 9.88801 13.0941 9.88801 13.9461C9.88757 14.7131 10.0764 15.4683 10.4379 16.1448C10.7993 16.8213 11.3222 17.3981 11.96 17.8241C11.2203 17.8005 10.4969 17.6007 9.85001 17.2411V17.3011C9.84994 18.3768 10.222 19.4195 10.9032 20.2521C11.5843 21.0847 12.5326 21.656 13.587 21.8691C12.9008 22.0548 12.1813 22.0821 11.483 21.9491C11.7805 22.8747 12.36 23.6841 13.1404 24.264C13.9208 24.8439 14.8629 25.1653 15.835 25.1831C14.1848 26.4785 12.1469 27.1812 10.049 27.1781C9.67739 27.1782 9.30609 27.1565 8.93701 27.1131C11.0665 28.4823 13.5454 29.2089 16.077 29.2061C24.647 29.2061 29.332 22.1081 29.332 15.9521C29.332 15.7521 29.327 15.5501 29.318 15.3501C30.2293 14.6911 31.0159 13.875 31.641 12.9401L31.643 12.9371Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b2db2c898f9e393ff8ad9e4f4b2a31b0.svg";
export { ForwardRef as ReactComponent };